import React from "react";
import Form from "react-bootstrap/Form";
import {Button, ListGroup} from "react-bootstrap";
import moment from "moment";
import * as backendUtils from "../helper/BackendUtils";
import {getErrorMessage} from "../helper/BackendUtils";
import {isWeekend, olderThanXDays, simplifyDate} from "../helper/DateUtils";
import {toast} from "react-toastify";

class Commute extends React.Component {
    constructor(props) {
        super(props);
        this.state = (
            {
                toWork: {checked: false, enabled: true},
                fromWork: {checked: false, enabled: true}
            }
        )
        this.backendUri = this.props.backendUri
        this.handleError = this.props.handleError
        this.handleDataSubmitted = this.props.handleSubmitted
    }

    componentDidMount() {
        this.readRecords(simplifyDate(this.props.current))
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.current !== this.props.current) {
            this.readRecords(simplifyDate(this.props.current))
        }
    }

    readRecords(date) {
        this.handleError(null)
        if (this.backendUri && this.props.user) {
            backendUtils.getRequest(`${this.backendUri}/${this.props.user}/${date}`, {},
                response => {
                    this.setCheckboxes(response.data)
                }, err => {
                    this.handleError(backendUtils.getErrorMessage(err));
                }
            ).catch((err) => this.handleError(err))
        }
    }

    setCheckboxes = (records) => {
        let toWork = {enabled: true, checked: false}
        let fromWork = {enabled: true, checked: false}
        records.map(commute => {
            if (commute.direction === 2)
                toWork = {enabled: !commute.isStrava, checked: true}
            if (commute.direction === 1)
                fromWork = {enabled: !commute.isStrava, checked: true}
        })
        this.setState({
            toWork: toWork,
            fromWork: fromWork
        })
    }

    commute = (direction) => {
        return {
            "date": simplifyDate(this.props.current),
            "direction": direction,
            "isStrava": false
        };
    }

    handleSubmit = () => {
        this.handleError(null)
        if (olderThanXDays(new Date(), this.props.current, 7)) {
            this.handleError("Cannot submit older than 7 days")
            return;
        }
        if (isWeekend(this.props.current)) {
            this.handleError("Cannot commute weekends")
            return;
        }
        if (this.isData2Sent()) {
            backendUtils.postRequest(`${this.backendUri}/${this.props.user}`, {}, this.prepareData(), response => {
                toast("Data submitted")
                return Promise.resolve(response.status);
            }, err => {
                this.handleError(getErrorMessage(err))
                return Promise.reject(getErrorMessage(err));
            }).then(() => {
                this.handleDataSubmitted(this.props.current);
            }).catch((err) => this.handleError(err))
        }
    }

    isData2Sent = () => {
        return this.backendUri && this.props.user !== "";
    }

    prepareData = () => {
        let data = []
        if (this.state.toWork.checked) {
            data.push(this.commute("2"))
        } else {
            data.push(this.commute("-2"))
        }
        if (this.state.fromWork.checked) {
            data.push(this.commute("1"))
        } else {
            data.push(this.commute("-1"))
        }
        return data
    }

    handleToWorkChanged(checked) {
        this.setState(({toWork}) => {
            return {toWork: {...toWork, checked: checked}}
        })
    }

    handleFromWorkChanged(checked) {
        this.setState(({fromWork}) => {
            return {fromWork: {...fromWork, checked: checked}}
        })
    }

    render() {
        return (<div>
                <Form>
                    <Form.Control value={moment(this.props.current).format("dddd MMMM Do YYYY")}
                                  readOnly={true} placeholder={"Date"}/>
                    <Form.Group>
                        <Form.Check type="checkbox" label="To Moto" inline checked={this.state.toWork.checked}
                                    disabled={!this.state.toWork.enabled}
                                    onChange={(e) => this.handleToWorkChanged(e.target.checked)}
                        />
                        <Form.Check type="checkbox" label="From Moto" inline checked={this.state.fromWork.checked}
                                    disabled={!this.state.fromWork.enabled}
                                    onChange={(e) => this.handleFromWorkChanged(e.target.checked)}
                        />
                    </Form.Group>
                    <Form.Group className="d-grid gap-2">
                        <Button variant="success" size="lg" disabled={this.props.user === ""}
                                onClick={this.handleSubmit}>Submit</Button>
                    </Form.Group>
                </Form>
                <br/>
            </div>
        )
    }

}

export default Commute

